import $ from 'jquery';

const wishlistCountUpdaterModule = (() => {

    /**
     * Create a new WishlistCountUpdater.
     *
     * @constructor
     */
    function WishlistCountUpdater() {
    }

    /**
     * Update the wishlist items count.
     * @param onUpdate the callback function executed on successful count update. The count value is passed as the first
     *  argument to the callback function.
     */
    WishlistCountUpdater.prototype.updateCount = function(onUpdate) {

        var self = this;

        $.ajax({
            type: 'POST',
            url: "/fw/ajax/GetWishlistItemsCount.jsp",
            success: function(ajaxResponse) {
                var responseObject = JSON.parse(ajaxResponse);
                if(responseObject.success) {
                    var count = responseObject.data;
                    if(count < 100) {
                        $("#wishlist_item_count").text(`(${count})`);
                    } else {
                        $("#wishlist_item_count").text("99+");
                    }
                    var limit = responseObject.limit;
                    $("#wishlist_item_count").data('count', count);
                    $("#wishlist_item_count").data('limit', limit);
                    if (responseObject.maxPopup) {
                        $('#wish-max-popup-div').empty().append(responseObject.maxPopup);
                    }
                    if(typeof onUpdate === 'function') {
                        onUpdate(count);
                    }
                }
            }
        });
    };

    WishlistCountUpdater.prototype.showWishListMaxRestrictionPopup = function() {
        var productCount = 0;
        var maxLimit = 0;
        var str = $("#wishlist_item_count").data('count');
        if (!Number.isNaN(Number(str))) {
            productCount = Number(str);
        }
        str = $("#wishlist_item_count").data('limit');
        if (!Number.isNaN(Number(str))) {
            maxLimit = Number(str);
        }
        if (productCount >= maxLimit && $("#restrict-favorites").length) {
            $.modal({triggerOpen:true, open: "restrict-favorites"});
            return true;
        }
        return false;
    };

    return {
        init : function () {
            if(typeof window.WishlistCountUpdater != 'function'){
                window.WishlistCountUpdater = WishlistCountUpdater;
            }
        }
    };
})();

export default wishlistCountUpdaterModule;


// WEBPACK FOOTER //
// ./src/scripts/modules/wishlist-count-updater.js